import { render, staticRenderFns } from "./NewExpense.vue?vue&type=template&id=2fca9b97&scoped=true&"
import script from "./NewExpense.vue?vue&type=script&lang=js&"
export * from "./NewExpense.vue?vue&type=script&lang=js&"
import style0 from "./NewExpense.vue?vue&type=style&index=0&id=2fca9b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca9b97",
  null
  
)

export default component.exports